import { create } from 'zustand';

interface ScrapeFloatingPanelStore {
  isOpen: boolean;
  openPanel: () => void;
  closePanel: () => void;
}

const useScrapeFloatingPanelStore = create<ScrapeFloatingPanelStore>((set) => ({
  isOpen: false,
  openPanel: () => set({ isOpen: true }),
  closePanel: () => set({ isOpen: false }),
}));

export default useScrapeFloatingPanelStore;
